module.exports = __webpack_public_path__ + "img/desc2.f41a2640.png";